// extracted by mini-css-extract-plugin
export var backdropBlur = "_hr-0";
export var contentCard = "_hr-5";
export var frame = "_hr-2";
export var image = "_hr-4";
export var imagePane = "_hr-3";
export var modal = "_hr-1";